import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { isValidDomain } from '@wix/domains-serverless-interface';
export const syncQueryToStore = query => {
  CoreDomainSearchStore.setTlds([]);
  CoreDomainSearchStore.setQuery(query);
  CoreDomainSearchStore.setStyle('');
  CoreDomainSearchStore.setKeywords([]);
  CoreDomainSearchStore.setSubmittedFilters({
    query,
    tlds: [],
    keywords: [],
    style: ''
  });
  if (isValidDomain(query)) {
    CoreDomainSearchStore.setSubmittedDomain(query);
  } else {
    CoreDomainSearchStore.setSubmittedDomain(undefined);
  }
};
//# sourceMappingURL=syncQueryToStore.js.map